import React from "react";
import { carrierFields } from "../formFields/asnTabsFields";
import GenericFormTab from "./GenericFormTab";

export default function CarrierTab({ formData, onChange, formSubmissionAttempted, readOnly }) {
  return (
    <GenericFormTab 
      fields={carrierFields} 
      formData={formData} 
      onChange={onChange} 
      formSubmissionAttempted={formSubmissionAttempted}
      readOnly={readOnly} // ✅ Pass through readOnly prop
    />
  );
}
